<template>
  <div class="Signup loginSignup">
    <div class="loginSignupBG shadow">
      <div class="title addText">Signup</div>
      <span> {{ errorMessage }}</span>
      <div class="emailInput">
        <input type="email" v-model="email" placeholder="email">
      </div>
      <div class="passwordInput">
        <input type="password" v-model="password" placeholder="password">
      </div>
      <div class="SLButton">
        <button v-on:click="signup" type="button" class="buttonBigStyle">Signup</button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Signup',
  data: function(){
      return {
        email: "",
        password: "",
        errorMessage: ""
      }
  },

  methods: {
    signup(e){
      this.$store.dispatch('signup',{
        email: this.email,
        password: this.password,
        callback: this.success,
        errorCallback: this.error
        });
      e.preventDefault();

    },

    success(){
      this.$router.push('/tournamentsOverview');
      this.email = "";
      this.password = "";
    },

    error(errorMessage){
      this.errorMessage = errorMessage;
    }



  }

}
</script>


<style scoped>
.emailInput{
  grid-area: emailInput;
}
.passwordInput{
  grid-area: passwordInput;
}
.SLButton{
  grid-area: button;
}

</style>



// WEBPACK FOOTER //
// src/components/Signup.vue